import { useLayoutEffect } from "react";
import { flushSync } from "react-dom";

// The native LINE header owns dismissal. Transitions here are horizontal and tap driven.
export function navigate(direction: "forward" | "back", update: () => void) {
  const doc = document as Document & {
    startViewTransition?: (update: () => void) => { finished: Promise<void> };
  };
  if (
    !doc.startViewTransition ||
    matchMedia("(prefers-reduced-motion: reduce)").matches
  ) {
    update();
    return;
  }
  document.documentElement.dataset.direction = direction;
  const transition = doc.startViewTransition(() => flushSync(update));
  void transition.finished.catch(() => {});
}

export function useAppViewport() {
  useLayoutEffect(() => {
    const viewport = window.visualViewport;
    let frame = 0;
    const update = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const root = document.documentElement;
        root.style.setProperty(
          "--app-height",
          `${viewport?.height ?? innerHeight}px`,
        );
        root.dataset.keyboard = String(
          innerHeight - (viewport?.height ?? innerHeight) > 120,
        );
      });
    };
    update();
    viewport?.addEventListener("resize", update);
    window.addEventListener("resize", update);
    return () => {
      cancelAnimationFrame(frame);
      viewport?.removeEventListener("resize", update);
      window.removeEventListener("resize", update);
    };
  }, []);
}
